import React from 'react';
import RightProductArrow from "../../images/RightProductArrow";
import {NavLink} from "react-router-dom";

interface HeaderCompanyItemProps {
	title: string;
	link: string;
	mode: 'dark' | 'light';
}

const HeaderCompanyItem = (props: HeaderCompanyItemProps) => {
	return (
		<NavLink
			className={`header_company_link ${props.mode}`}
			to={`/${props.link}`}
		>
			<h4>{props.title}</h4>
			<RightProductArrow color={props.mode === 'dark' ? "#fff" : "#080015"} />
		</NavLink>
	);
};

export default HeaderCompanyItem;